module.exports = __webpack_public_path__ + "static/img/icon-first-activity.ed5acffd.png";